import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getEventItemId from 'owa-calendar-types/lib/utils/getEventItemId';
import CalendarSurfaceStore from '../schema/CalendarSurfaceStore';
import { action } from 'satcheljs/lib/legacy';

export let addCalendarItems = action('addCalendarItems')(function addCalendarItems(
    itemsAdded: CalendarEvent[],
    store: CalendarSurfaceStore,
    replaceAll: boolean = false
): void {
    if (replaceAll) {
        store.calendarItems = [];
    }
    if (itemsAdded) {
        /**
         * We need to filter out events that are already in the store, because we are using this action to keep
         * this store in sync with `owa-calendar-events-store` after events are loaded. This can result in multiple calls to this
         * action with duplicated events. To avoid adding these dupes to the store, we need to filter them out.
         *
         * This will not be needed once VSO 30430: Stop re-storing calendar events in the calendar module / Syncing between SurfaceStore and Cache should be removed
         * is complete
         */
        const newItemsAdded = itemsAdded.filter(
            itemToAdd =>
                store.calendarItems.filter(
                    event => getEventItemId(event) === getEventItemId(itemToAdd)
                ).length <= 0
        );
        store.calendarItems.push(...newItemsAdded);
    }
});
